package com.eladfinish.bible.contest.screens.search.ui.dialogs

import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.Spacer
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.layout.size
import androidx.compose.foundation.layout.width
import androidx.compose.material3.BasicAlertDialog
import androidx.compose.material3.CardDefaults
import androidx.compose.material3.CircularProgressIndicator
import androidx.compose.material3.ExperimentalMaterial3Api
import androidx.compose.material3.MaterialTheme
import androidx.compose.material3.OutlinedCard
import androidx.compose.material3.ShapeDefaults
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.tooling.preview.Preview
import androidx.compose.ui.unit.dp
import androidx.compose.ui.unit.sp
import com.eladfinish.bible.contest.SharedRes
import com.eladfinish.bible.contest.colorAccent
import com.eladfinish.bible.contest.screens.search.model.SearchNumberOrRoot
import com.eladfinish.bible.contest.ui.common.PreviewTheme
import dev.icerock.moko.resources.compose.colorResource
import dev.icerock.moko.resources.compose.localized
import dev.icerock.moko.resources.compose.stringResource
import dev.icerock.moko.resources.desc.StringDesc
import dev.icerock.moko.resources.desc.desc

@OptIn(ExperimentalMaterial3Api::class)
@Composable
internal fun LoadingMessageDialog(
    onDismiss: () -> Unit,
    sentence: StringDesc,
) {
    BasicAlertDialog(
        onDismissRequest = onDismiss,
        content = {
            LoadingMessageDialogContent(sentence)
        }
    )
}

@Composable
private fun LoadingMessageDialogContent(
    sentence: StringDesc,
) {
    OutlinedCard(
        shape = ShapeDefaults.Medium,
        colors = CardDefaults.elevatedCardColors(),
        elevation = CardDefaults.elevatedCardElevation(),
        content = {
            Row(
                modifier = Modifier
                    .fillMaxWidth()
                    .padding(horizontal = 8.dp, vertical = 16.dp),
                horizontalArrangement = Arrangement.Center,
                verticalAlignment = Alignment.CenterVertically,
            ) {
                CircularProgressIndicator(
                    modifier = Modifier.size(36.dp),
                    color = colorResource(resource = SharedRes.colors.colorAccent),
                )
                Spacer(modifier = Modifier.width(24.dp))
                Text(
                    text = sentence.localized(),
                    style = MaterialTheme.typography.bodyMedium.copy(
                        fontSize = 16.sp,
                    ),
                )
            }
        },
    )
}

@Preview(heightDp = 100)
@Composable
private fun LoadingMessageDialogNumberPreview() {
    val sentence = SearchNumberOrRoot.NUMBER.stringRes.let {
        stringResource(it, 123)
    }

    PreviewTheme {
        LoadingMessageDialog(
            sentence = sentence.desc(),
            onDismiss = {},
        )
    }
}

@Preview(heightDp = 100)
@Composable
private fun LoadingMessageDialogRootPreview() {
    val sentence = SearchNumberOrRoot.ROOT.stringRes.let {
        stringResource(it, "ברא")
    }

    PreviewTheme {
        LoadingMessageDialogContent(
            sentence = sentence.desc(),
        )
    }
}

@Preview(heightDp = 100)
@Composable
private fun LoadingMessageDialogDatePreview() {
    val sentence = SearchNumberOrRoot.DATE.stringRes.let {
        stringResource(it, "י׳ בתשרי (החודש השביעי)")
    }

    PreviewTheme {
        LoadingMessageDialogContent(
            sentence = sentence.desc(),
        )
    }
}
